import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterValueListService, FilterValue } from '../filter/types';
import { ClaimService } from '../../core/services/claims.service';
import { ClaimOption } from '../../core/types/claim';

@Injectable()
export class ClaimOptionValueListService implements FilterValueListService {
  constructor(private claims: ClaimService) {}

  getFilterValues$(): Observable<FilterValue[]> {
    return this.claims.getClaimOptions$().pipe(
      map((claimOptions: ClaimOption[]): FilterValue[] => {
        return claimOptions.map(
          (claimOption: ClaimOption): FilterValue => {
            return {
              value: claimOption.code,
              displayText: claimOption.name,
            };
          }
        );
      })
    );
  }
}
